(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8124);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7809:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-play-circle.86a33328.svg","height":36,"width":36});

/***/ }),

/***/ 7719:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-bank-api.94ed5642.png","height":212,"width":478,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAhUlEQVR42mNkkJ2rycDHZMRwNXGpSfBym3//GBjOrY88wiA1N4qBjfEiY0Xrjgviwpz6hRmnI1dtcJ7JCASh/utSJ8xwXnH/6ZdLLG/e/7zx588/VQaG7/d//Pxzk5GRgZGB4deDL99+f/37998NBiBgZmCoFGMAAiAtwcBQLgFhF4DEmAHLMTGHhzqRXAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 3050:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/image-neobank-sdk.4cdef311.png","height":294,"width":491,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAnElEQVR42mOwC12mERq9aLa233J9Bsu1gsYByyaFRC3apey7PJcBBKSs5wqHRi5YwMC/icMxZEm3c8iSJ66hS74zeK5MYACBGQuOe+TU7JjGYLc0NSZuYXxA5KJ5IPGs5Lke2clzBRmyKrdsSCradE3RfYkBAwi4rZIDUcXps73Tk+ZJM+RVb52QW72tHyRYWbyEGUQnxM9nZoACAEUINBhXmd4eAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-digibank.ff1a1b85.png","height":162,"width":471,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbklEQVR4nGMMcVfm+Pydk4WXh+ePgjTn3ws3v7GdvP31u7IoIzMTE/MfxuRgRa8X79gUn77jeSbEx8zw5dsfid9//r9mZGQQYGFh2czo5aDOzsPN9X/VVrZ/3LJ/mBQFmRmE+FgZGBiYGIAK/gAAQ5AhEp5UgzgAAAAASUVORK5CYII="});

/***/ }),

/***/ 1500:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-101pay.3fb23a97.png","height":185,"width":369,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAYElEQVR42mNIUDrP7iZ1iZOB4T+HueZUfjZjBjYGZBAmd0ksQfls9GSToy1uWvMmMBhqpivpx8TI6of6ALEAA1An0yKbLSa3groC1ZRXmooZMygo6kc5AyWDgJiVgRAAAH7PF9+zaBGbAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 6837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterHalfCircle_FooterHalfCircle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
// EXTERNAL MODULE: ./src/components/Button/index.ts + 1 modules
var Button = __webpack_require__(599);
;// CONCATENATED MODULE: ./public/footer-half-circle/bg-grid.png
/* harmony default export */ var bg_grid = ({"src":"/_next/static/media/bg-grid.16124e29.png","height":402,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAKElEQVR42mNQ8Z/LpBwAxDDaZw4KZlD2ms2kBOJ4z2FS8p6NkPSF0AAvVBDdxfVkmgAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/containers/FooterHalfCircle/FooterHalfCircle.tsx







var FooterHalfCircle = function(param) {
    var buttonLink = param.buttonLink, buttonTitle = param.buttonTitle, title = param.title, description = param.description;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        pos: "relative",
        alignItems: "center",
        justify: "center",
        w: "100%",
        minH: [
            "250px",
            null,
            null,
            null,
            null,
            "400px"
        ],
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                pos: "absolute",
                w: "1920px",
                left: "50%",
                transform: "translateX(-50%)",
                top: "0",
                zIndex: "-1",
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: bg_grid,
                    alt: "101Pay",
                    objectFit: "cover",
                    objectPosition: "center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                align: "center",
                flexDir: "column",
                justify: "center",
                p: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "0px 12%",
                    null,
                    "0px 16%",
                    "0px 20%", 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        mb: [
                            "10px",
                            null,
                            null,
                            null,
                            null,
                            "34px"
                        ],
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "48px"
                        ],
                        fontWeight: "300",
                        textAlign: "center",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                        maxWidth: [
                            "300px",
                            null,
                            null,
                            "514px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                textStyle: "paragraph",
                                mb: [
                                    "53px"
                                ],
                                fontSize: [
                                    "0.875rem",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "21px"
                                ],
                                textAlign: "center",
                                fontWeight: "300",
                                children: description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: "#",
                                minW: [
                                    "291px",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "444px"
                                ],
                                onClick: function() {
                                    return router.push(buttonLink);
                                },
                                m: "auto",
                                display: "block",
                                variant: "outline",
                                mb: [
                                    "auto",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "5px"
                                ],
                                children: buttonTitle
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var FooterHalfCircle_FooterHalfCircle = (FooterHalfCircle);

;// CONCATENATED MODULE: ./src/containers/FooterHalfCircle/index.ts



/***/ }),

/***/ 4314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ModalWatchVideo_ModalWatchVideo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/esm/use-media-query.js
var use_media_query = __webpack_require__(1768);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/esm/modal.js + 67 modules
var modal = __webpack_require__(3874);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
;// CONCATENATED MODULE: ./src/containers/ModalWatchVideo/ModalWatchVideo.tsx



function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var ModalWatchVideo = function(_param) {
    var src = _param.src, otherProps = _objectWithoutProperties(_param, [
        "src"
    ]);
    var ref = _slicedToArray((0,use_media_query/* useMediaQuery */.a)("(min-width: 1024px)"), 1), isDesktop = ref[0];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal */.u_, _objectSpread({
    }, otherProps, {
        isCentered: !isDesktop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* ModalOverlay */.ZA, {
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* ModalContent */.hz, {
                maxW: [
                    "90vw",
                    null,
                    null,
                    null,
                    null,
                    "980px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* ModalCloseButton */.ol, {
                        zIndex: 2,
                        top: 0,
                        right: 0,
                        background: "#fff",
                        borderRadius: "50%",
                        transform: "translate(50%, -50%)",
                        _hover: {
                            background: "#fff"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "relative",
                        height: "100vh",
                        maxH: [
                            "60vw",
                            null,
                            null,
                            null,
                            null,
                            "650px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            width: "100%",
                            height: "100%",
                            src: src,
                            frameBorder: "0"
                        })
                    })
                ]
            })
        ]
    })));
};
/* harmony default export */ var ModalWatchVideo_ModalWatchVideo = (ModalWatchVideo);

;// CONCATENATED MODULE: ./src/containers/ModalWatchVideo/index.ts



/***/ }),

/***/ 8124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/esm/use-disclosure.js + 1 modules
var use_disclosure = __webpack_require__(4126);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/esm/use-media-query.js
var use_media_query = __webpack_require__(1768);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/flex.js
var flex = __webpack_require__(4096);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/esm/slide-fade.js
var slide_fade = __webpack_require__(454);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/text.js
var esm_text = __webpack_require__(4115);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/box.js
var box = __webpack_require__(8017);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/esm/stack.js + 2 modules
var stack = __webpack_require__(234);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 11 modules
var Layout = __webpack_require__(8077);
// EXTERNAL MODULE: ./src/components/Link/index.ts + 1 modules
var Link = __webpack_require__(8030);
// EXTERNAL MODULE: ./src/components/Image/index.ts + 1 modules
var Image = __webpack_require__(8331);
// EXTERNAL MODULE: ./src/components/Button/index.ts + 1 modules
var Button = __webpack_require__(599);
;// CONCATENATED MODULE: ./src/containers/HomeCard/HomeCard.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HomeCard = function(_param) {
    var imageSrc = _param.imageSrc, title = _param.title, imageAltText = _param.imageAltText, content = _param.content, isReversed = _param.isReversed, spacing = _param.spacing, props = _objectWithoutProperties(_param, [
        "imageSrc",
        "title",
        "imageAltText",
        "content",
        "isReversed",
        "spacing"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, _objectSpread({
        flexDir: "column",
        align: [
            "center",
            null,
            null,
            null,
            null,
            "flex-start"
        ],
        justify: "flex-start",
        maxW: [
            "none",
            null,
            null,
            null,
            null,
            "911px"
        ],
        minH: [
            "unset",
            null,
            null,
            null,
            null,
            "343px"
        ],
        border: "none",
        borderRadius: "5px"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                display: "flex",
                alignItems: "flex-start",
                m: [
                    "0 auto 20px",
                    null,
                    null,
                    null,
                    null,
                    "0 0 43.8px 24px"
                ],
                height: [
                    "auto",
                    null,
                    null,
                    null,
                    null,
                    "204px"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageSrc,
                    alt: imageAltText !== null && imageAltText !== void 0 ? imageAltText : title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        fontSize: [
                            "1rem",
                            null,
                            null,
                            null,
                            null,
                            "24px"
                        ],
                        fontWeight: "700",
                        lineHeight: [
                            "1.25rem",
                            null,
                            null,
                            null,
                            null,
                            "35.3px"
                        ],
                        color: "black",
                        maxW: "416px",
                        m: [
                            "0 auto 15px",
                            null,
                            null,
                            null,
                            null,
                            "0 0 35px"
                        ],
                        textAlign: [
                            "center",
                            null,
                            null,
                            null,
                            null,
                            "start"
                        ],
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        fontSize: [
                            "14px",
                            null,
                            null,
                            null,
                            null,
                            "21px"
                        ],
                        fontWeight: "300",
                        lineHeight: [
                            "20px",
                            null,
                            null,
                            null,
                            null,
                            "25.62px"
                        ],
                        color: "gray",
                        textAlign: [
                            "center",
                            null,
                            null,
                            null,
                            null,
                            "start"
                        ],
                        children: content
                    })
                ]
            })
        ]
    })));
};
/* harmony default export */ var HomeCard_HomeCard = (HomeCard);

;// CONCATENATED MODULE: ./src/containers/HomeCard/index.ts


;// CONCATENATED MODULE: ./src/containers/HomeStepCard/HomeStepCard.tsx


var HomeStepCard = function(param) {
    var step = param.step, title = param.title, description = param.description;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        flexDir: "column",
        align: "center",
        w: "100%",
        maxW: [
            "248px",
            null,
            null,
            null,
            null,
            "377px"
        ],
        borderRadius: [
            "6.61386px",
            null,
            null,
            null,
            null,
            "10.0541px"
        ],
        boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.1)",
        background: "#fff",
        pos: "relative",
        pt: [
            "30.79px",
            null,
            null,
            null,
            null,
            "46.81px"
        ],
        pb: [
            "23.37px",
            null,
            null,
            null,
            null,
            "35.53px"
        ],
        px: [
            "22px",
            null,
            null,
            null,
            null,
            "34px"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                w: [
                    "49.46px",
                    null,
                    null,
                    null,
                    null,
                    "75.18px"
                ],
                h: [
                    "49.46px",
                    null,
                    null,
                    null,
                    null,
                    "75.18px"
                ],
                align: "center",
                justify: "center",
                borderRadius: "50%",
                boxShadow: "0px 0px 4px 0px #00000040",
                bgColor: "white",
                pos: "absolute",
                top: "0",
                transform: "translate(0, -50%)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                    as: "span",
                    fontSize: [
                        "0.875rem",
                        null,
                        null,
                        null,
                        null,
                        "2.25rem"
                    ],
                    fontWeight: "700",
                    lineHeight: [
                        "1rem",
                        null,
                        null,
                        null,
                        null,
                        "1.5rem"
                    ],
                    children: step
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                fontSize: [
                    "0.875rem",
                    null,
                    null,
                    null,
                    null,
                    "1.445rem"
                ],
                fontWeight: "700",
                lineHeight: [
                    "1.38875rem",
                    null,
                    null,
                    null,
                    null,
                    "2.11125rem"
                ],
                letterSpacing: [
                    "0.83px",
                    null,
                    null,
                    null,
                    null,
                    "1.27px"
                ],
                color: "secondary",
                mb: [
                    "11.62px",
                    null,
                    null,
                    null,
                    null,
                    "17.67px"
                ],
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                fontSize: [
                    "0.875rem",
                    null,
                    null,
                    null,
                    null,
                    "1.375rem"
                ],
                fontWeight: "400",
                lineHeight: [
                    "1.233125rem",
                    null,
                    null,
                    null,
                    null,
                    "1.875rem"
                ],
                textAlign: "center",
                maxW: [
                    "203px",
                    null,
                    null,
                    null,
                    null,
                    "unset"
                ],
                children: description
            })
        ]
    }));
};
/* harmony default export */ var HomeStepCard_HomeStepCard = (HomeStepCard);

;// CONCATENATED MODULE: ./src/containers/HomeStepCard/index.ts


;// CONCATENATED MODULE: ./public/home/hero.svg
/* harmony default export */ var hero = ({"src":"/_next/static/media/hero.7786cd5c.svg","height":745,"width":1050});
;// CONCATENATED MODULE: ./public/home/speed.svg
/* harmony default export */ var speed = ({"src":"/_next/static/media/speed.c7260904.svg","height":138,"width":182});
;// CONCATENATED MODULE: ./public/home/speed-small.png
/* harmony default export */ var speed_small = ({"src":"/_next/static/media/speed-small.18c0bdaf.png","height":104,"width":137,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAmElEQVR42i1Nuw4CMQzr38AAn87KhsSAmBAbbAzodHd9pG1aENCWIySISJHtyHaUTNeZuYewZazW+Mq4o6kslEwrz5nRAHoECj6Sh0jOBep7m1gv1TC4jdZAGFNJmNiExLfKITHvFbjwcNbTPWc6na90OF7olrK0fLjlrcbBZXFLWpr+/IccfimMuIoB5X9jPsmybmKwxq+/e6yneo5f09wAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/home/experts.svg
/* harmony default export */ var experts = ({"src":"/_next/static/media/experts.22cffd2f.svg","height":165,"width":262});
;// CONCATENATED MODULE: ./public/home/experts-small.png
/* harmony default export */ var experts_small = ({"src":"/_next/static/media/experts-small.fe526aa0.png","height":87,"width":137,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAnklEQVR42i3NQQqCQBjF8blAbbpDm27R4bpBmxYV3aB9a6EkwkUQlRhTaebMmCMf9on4GqHf8sHjL4zWQwaG1tqRcLiup0Yp2OKDL/NCMDOVxlBVVYiT1xjA8uAfcT7d4KwEEWG78aC1Rp7nbfdMUsPykYGonAk3RpdQhoW1RbAPsPN8tG2zRiN76VsNukRfOEplE3l/4hpGSOJ4Lv5+tgl9u8Xq32AAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/home/partnership.svg
/* harmony default export */ var partnership = ({"src":"/_next/static/media/partnership.6f4a30d5.svg","height":204,"width":144});
;// CONCATENATED MODULE: ./public/home/partnership-small.png
/* harmony default export */ var partnership_small = ({"src":"/_next/static/media/partnership-small.4036b542.png","height":134,"width":95,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAA00lEQVR4nAHIADf/Af///wCSdXqsUklGe7XE7dnz5fGOxe8LvwHM6PUOC/Hww+jb4V/17O7Q6uTsqtTl8uUB3ubxJ/4BAdj6+PmZ1aWyrqvl/7L/8Ov3AZKbvwzu9QDoLB4OuPnY0oWnzv3OCwbxvgEkRaER3O/+7kMYBIwvHCV17vO//PkABWEBMlSqKAL++9Ph+ACGFxMafyT3xOoJBwVcATtVpFn4+/5XEQf8ysP0HoZMCsfhBQUFfQFXYphAAAAC//v+Bujr9Qb3EwDhfAMCAacYX27ooGGx3QAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./public/logo-101pay.png
var logo_101pay = __webpack_require__(1500);
// EXTERNAL MODULE: ./public/home/image-bank-api.png
var image_bank_api = __webpack_require__(7719);
;// CONCATENATED MODULE: ./public/home/image-bank-api-hover.png
/* harmony default export */ var image_bank_api_hover = ({"src":"/_next/static/media/image-bank-api-hover.4a5fb43a.png","height":212,"width":478,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAb0lEQVR42mP4//+/JhBHAzHD799/bEAYxAbiKCDWZnj/4cuFl68+/AeCiDPnH3w8fe7BJyA7/Nad5/9fv/l0keHjp68r3rz99BUoaH7pyuNTF688Pg1i33/w8svrNx9XgoxiBmIxqLESUMwAFWMGAHYmaRRqCfztAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./public/home/image-neobank-sdk.png
var image_neobank_sdk = __webpack_require__(3050);
;// CONCATENATED MODULE: ./public/home/image-neobank-sdk-hover.png
/* harmony default export */ var image_neobank_sdk_hover = ({"src":"/_next/static/media/image-neobank-sdk-hover.7d93cbf6.png","height":293,"width":491,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAkklEQVR42i3KMQoCMRAF0IEt7NdSsLbTYyx4B61sPYmFFmKlZ/ACXkMQWwthcRNMssFkMvEHtnjM/M+nxDxLv/6cc55DLSJH5Bv+LRDlLGMUF4SRcNzBSzg45DUQPZ7vptP9CWHD3q5S8GVM0aoGalLaXY3xd5QLIJgChW+7jE5PqOvsQSm3L6X9tFW57E01jOkPrwmBVjYFSYAAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/home/image-preview-101-pay.png
/* harmony default export */ var image_preview_101_pay = ({"src":"/_next/static/media/image-preview-101-pay.c7966958.png","height":506,"width":471,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA80lEQVR4nAHoABf/AVIms/D04/gPBPcH/EWI+Zo4PyRd9evpCBARC+wBbkPN/x4mFwDi0vYAFz3RuTxFQkcvBOUA+vfnAAF4TM/9JTAWAuLX+P8PM9G2Zm1GSQYHCwLn5+n9AXhP2PtTfR4Ez7Xu//MC0bBhbzxQEAwOAeno6PsBiEjW+lyYIAXTyvf/wKKvrGyMOFMbJysC6enp+wG6e9v9MFIJAsDLDP+9qrfDO1oRO1NdRgPf3OX8AdW0qvT78SwLw78a+tz2mviRubcO28ifAP39/vkBnXYAKs/8hQ723yPyCv2NPOr0DGM5MyesFztHtaXjddwnVYXwAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/home/image-preview-digibank.png
/* harmony default export */ var image_preview_digibank = ({"src":"/_next/static/media/image-preview-digibank.14e2dcfd.png","height":454,"width":589,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAwklEQVR42hXDzWkCQRgG4He+mZ2sMoQYWAwkuQlJIJBDGkgD6SCQGmzCCqzEg94EtQUv3vW6uKMuO9/8iQ88YrZYTuy5c1rm3qF4m45/R/ucswKQb8Vu/r8dVk/Ruv5d4E4Z02cCC9V7JYnTWennvw8avlDpE3L0eBgM4NkhQUKjTSo/frVlVZlgbYIgKu4NEIHgGUWpWWnBRDmCRKQYfAOYgMSQIskU/Ymaxl7qusbx2LTrzeoHwMg5/pSqeO9c+L4CokVX175ZbyYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/home/bg-circle-right.svg
/* harmony default export */ var bg_circle_right = ({"src":"/_next/static/media/bg-circle-right.59d2a863.svg","height":1366,"width":1090});
;// CONCATENATED MODULE: ./public/home/bg-circle-left.svg
/* harmony default export */ var bg_circle_left = ({"src":"/_next/static/media/bg-circle-left.45dacb14.svg","height":1022,"width":780});
// EXTERNAL MODULE: ./public/home/icon-play-circle.svg
var icon_play_circle = __webpack_require__(7809);
// EXTERNAL MODULE: ./public/home/logo-digibank.png
var logo_digibank = __webpack_require__(4881);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/containers/FooterHalfCircle/index.ts + 2 modules
var FooterHalfCircle = __webpack_require__(6837);
// EXTERNAL MODULE: ./src/containers/ModalWatchVideo/index.ts + 1 modules
var ModalWatchVideo = __webpack_require__(4314);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/pages/index.tsx































function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var dataBankingService = [
    {
        key: "bank-api",
        title: "Bank-API:\nOpen Banking as a Service",
        description: "For banks & fintechs wanting to launch Open Banking Solutions.",
        link: "https://www.youtube.com/embed/NCyFlX9AFuQ",
        image: image_bank_api/* default */.Z,
        imageHover: image_bank_api_hover
    },
    {
        key: "neobank",
        title: "Neobank SDK:\nNeobank as a Service",
        description: "For bank & fintechs wishing to disrupt the market with innovative Digital / Embedded Finance Solutions.",
        link: "https://www.youtube.com/embed/OSerkQYuzjg",
        image: image_neobank_sdk/* default */.Z,
        imageHover: image_neobank_sdk_hover
    }, 
];
var Index = function() {
    var ref = (0,use_disclosure/* useDisclosure */.q)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = (0,react.useState)(""), urlVideo = ref1[0], setUrlVideo = ref1[1];
    var router = (0,next_router.useRouter)();
    var ref2 = _slicedToArray((0,use_media_query/* useMediaQuery */.a)("(min-width: 1024px)"), 1), isDesktop = ref2[0];
    var handleOpenWatchVideoModal = function(url) {
        setUrlVideo(url);
        onOpen();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "101Digital | Next Gen Banking - 101 Digital"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWatchVideo/* default */.Z, {
                isOpen: isOpen,
                onClose: onClose,
                src: urlVideo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                w: "100%",
                align: "center",
                flexDir: [
                    "column",
                    null,
                    null,
                    null,
                    null,
                    "row"
                ],
                mt: [
                    "45px",
                    null,
                    null,
                    null,
                    null,
                    "48px"
                ],
                mb: [
                    "61px",
                    null,
                    null,
                    null,
                    null,
                    "172px"
                ],
                ml: [
                    null,
                    null,
                    null,
                    "auto",
                    null,
                    null,
                    0
                ],
                pl: [
                    0,
                    null,
                    null,
                    null,
                    null,
                    "16px",
                    "12%",
                    null,
                    "16%",
                    "20%"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        flexDir: "column",
                        align: [
                            "center",
                            null,
                            null,
                            null,
                            null,
                            "flex-start"
                        ],
                        maxW: "603px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(slide_fade/* SlideFade */.R, {
                            in: true,
                            offsetY: "50px",
                            transition: {
                                enter: {
                                    duration: 1
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* Text */.x, {
                                    as: "h1",
                                    textStyle: "h1",
                                    textAlign: [
                                        "center",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "left"
                                    ],
                                    mb: [
                                        "13px",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "15px"
                                    ],
                                    fontSize: [
                                        "36px",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "64px"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            children: "Digital Finance"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                            color: "secondary",
                                            children: "Accelerated"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                    textStyle: "paragraphHighlighted",
                                    textAlign: [
                                        "center",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "left"
                                    ],
                                    px: [
                                        "61px",
                                        null,
                                        null,
                                        null,
                                        null,
                                        0
                                    ],
                                    mb: [
                                        "16px",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "32px"
                                    ],
                                    fontWeight: "300",
                                    children: "We deliver world class digital platforms that enable your business growth and customer acquisition"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "/products",
                                    pos: [
                                        "absolute",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "static"
                                    ],
                                    top: "16px",
                                    w: "147.72px",
                                    color: "#fff",
                                    bgColor: "primary",
                                    borderRadius: "md",
                                    textAlign: "center",
                                    justifyContent: "center",
                                    display: [
                                        "none",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "flex"
                                    ],
                                    style: {
                                        textDecoration: "none"
                                    },
                                    alignItems: "center",
                                    left: "16px",
                                    height: [
                                        "40px",
                                        null,
                                        null,
                                        null,
                                        null,
                                        "54px"
                                    ],
                                    textStyle: "buttonText",
                                    children: "Tell me more"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        maxW: [
                            null,
                            null,
                            null,
                            null,
                            null,
                            "1050px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slide_fade/* SlideFade */.R, {
                            in: true,
                            offsetY: "50px",
                            transition: {
                                enter: {
                                    duration: 1
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: hero,
                                alt: "Reach customers globally in Transport, Leisure, Education, Entertainment, Employment, Family, and Health industries"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "/products",
                        w: "291px",
                        h: "32px",
                        mr: "27px",
                        mt: "23px",
                        mx: "auto",
                        color: "#fff",
                        bgColor: "primary",
                        borderRadius: "md",
                        textAlign: "center",
                        justifyContent: "center",
                        display: [
                            "flex",
                            null,
                            null,
                            null,
                            null,
                            "none"
                        ],
                        style: {
                            textDecoration: "none"
                        },
                        alignItems: "center",
                        textStyle: "buttonText",
                        children: "Tell me more"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                as: "h2",
                textStyle: "h2",
                mb: [
                    "20px",
                    null,
                    null,
                    null,
                    null,
                    "27px"
                ],
                fontSize: [
                    "18px",
                    null,
                    null,
                    null,
                    null,
                    "48px"
                ],
                children: "The 101 Digital Advantage"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                textStyle: "paragraph",
                textAlign: "center",
                px: "66px",
                mb: [
                    "38px",
                    null,
                    null,
                    null,
                    null,
                    "136.56px"
                ],
                fontSize: [
                    "14px",
                    null,
                    null,
                    null,
                    null,
                    "21px"
                ],
                fontWeight: "300",
                children: "Our ready made (as a Service) platform accelerates your product launch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                mb: [
                    "45px",
                    null,
                    null,
                    null,
                    null,
                    "244px"
                ],
                maxW: "1160px",
                w: "100%",
                p: [
                    "16px"
                ],
                flexWrap: [
                    "wrap",
                    null,
                    null,
                    null,
                    null,
                    "nowrap"
                ],
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "none",
                            null,
                            null,
                            null,
                            null,
                            "flex"
                        ],
                        imageSrc: speed,
                        imageAltText: "Speed up product delivery",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Accelerate your ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                }),
                                " product launch"
                            ]
                        }),
                        content: "Use our proven platform and expertise to launch successful digital products."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "flex",
                            null,
                            null,
                            null,
                            null,
                            "none"
                        ],
                        imageSrc: speed_small,
                        imageAltText: "Speed up product delivery",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Accelerate your ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                }),
                                " product launch"
                            ]
                        }),
                        content: "Use our proven platform and expertise to launch successful digital products."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "none",
                            null,
                            null,
                            null,
                            null,
                            "flex"
                        ],
                        imageSrc: experts,
                        imageAltText: "Work with domain and technology experts",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Engage with digital",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                }),
                                "platform experts"
                            ]
                        }),
                        content: "Collaborate with a team with a proven track record in delivering exceptional digital products.",
                        isReversed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "flex",
                            null,
                            null,
                            null,
                            null,
                            "none"
                        ],
                        imageSrc: experts_small,
                        imageAltText: "Work with domain and technology experts",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Engage with digital",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                }),
                                "platform experts"
                            ]
                        }),
                        content: "Collaborate with a team with a proven track record in delivering exceptional digital products.",
                        isReversed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "none",
                            null,
                            null,
                            null,
                            null,
                            "flex"
                        ],
                        imageSrc: partnership,
                        imageAltText: "Invest in a partnership",
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Invest in a",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                }),
                                "Partnership"
                            ]
                        }),
                        content: "Be empowered by a partnership that complements you every step of the way - from ideation to product launch."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCard_HomeCard, {
                        flex: [
                            "0 0 100%",
                            null,
                            null,
                            null,
                            null,
                            "0 0 300px"
                        ],
                        maxW: [
                            "100%",
                            null,
                            null,
                            null,
                            null,
                            "300px"
                        ],
                        mb: [
                            "40px",
                            null,
                            null,
                            null,
                            null,
                            "0"
                        ],
                        display: [
                            "flex",
                            null,
                            null,
                            null,
                            null,
                            "none"
                        ],
                        imageSrc: partnership_small,
                        imageAltText: "Invest in a partnership",
                        title: "Invest in a Partnership",
                        content: "Be empowered by a partnership that complements you every step of the way - from ideation to product launch."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                pos: "relative",
                flexDir: "column",
                alignItems: "center",
                w: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "absolute",
                        width: [
                            "360px",
                            "auto"
                        ],
                        right: [
                            "-60px",
                            "0px"
                        ],
                        top: "-169px",
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_right,
                            alt: "101Pay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        mb: [
                            "20px",
                            null,
                            null,
                            null,
                            null,
                            "39px"
                        ],
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "48px"
                        ],
                        textAlign: [
                            "center",
                            null,
                            null,
                            "left"
                        ],
                        children: "Innovation Powered by Platform as a Service"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        textStyle: "paragraph",
                        textAlign: "center",
                        maxW: [
                            "300px",
                            null,
                            null,
                            "1050px"
                        ],
                        mb: [
                            "38px",
                            null,
                            null,
                            null,
                            null,
                            "55px"
                        ],
                        fontSize: [
                            "14px",
                            null,
                            null,
                            null,
                            null,
                            "21px"
                        ],
                        fontWeight: "300",
                        children: "Accelerated product launch, reduced costs and risks, and a superior customer experience"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        justifyContent: [
                            "center",
                            null,
                            null,
                            "space-between"
                        ],
                        alignItems: [
                            "center",
                            null,
                            null,
                            "unset"
                        ],
                        w: "100%",
                        maxW: "1182px",
                        px: "16px",
                        mb: [
                            null,
                            null,
                            null,
                            "85px"
                        ],
                        children: dataBankingService.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                flex: [
                                    "100%",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "0 0 calc(50% - 15px)"
                                ],
                                flexDir: [
                                    "column",
                                    null,
                                    null,
                                    null,
                                    null,
                                    "row"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                        role: "group",
                                        w: "100%",
                                        maxW: "560px",
                                        boxShadow: [
                                            "null",
                                            "null",
                                            "null",
                                            "0px 0px 12px rgba(0, 0, 0, 0.1)", 
                                        ],
                                        borderRadius: "25px",
                                        p: [
                                            "50px 30px",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "70px 50px"
                                        ],
                                        mb: [
                                            "0",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "85px"
                                        ],
                                        bg: [
                                            "transparent",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "#fff"
                                        ],
                                        cursor: "pointer",
                                        _hover: {
                                            bg: "#2D4FA7"
                                        },
                                        pointerEvents: [
                                            "none",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "auto"
                                        ],
                                        onClick: function(e) {
                                            return isDesktop ? handleOpenWatchVideoModal(item.link) : e.preventDefault();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                textStyle: "h3",
                                                fontSize: [
                                                    "16px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "36px"
                                                ],
                                                textAlign: [
                                                    "center",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "left"
                                                ],
                                                fontWeight: "700",
                                                color: "#102542",
                                                m: [
                                                    "0 0 45px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "0 0 90px 10px"
                                                ],
                                                maxW: [
                                                    "unset",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "265px"
                                                ],
                                                whiteSpace: "pre-wrap",
                                                _groupHover: {
                                                    color: "#fff"
                                                },
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                                                pos: "relative",
                                                maxW: [
                                                    item.key === "bank-api" ? "220px" : "280px",
                                                    null,
                                                    null,
                                                    "unset", 
                                                ],
                                                m: item.key === "bank-api" ? [
                                                    "0 auto",
                                                    null,
                                                    null,
                                                    "0"
                                                ] : [
                                                    "0 auto",
                                                    null,
                                                    null,
                                                    "-60px 0 -11px"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                                        _groupHover: {
                                                            opacity: 0
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.image,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                                        pos: "absolute",
                                                        top: "0",
                                                        left: "0",
                                                        w: "100%",
                                                        h: "100%",
                                                        pointerEvents: "none",
                                                        opacity: "0",
                                                        _groupHover: {
                                                            opacity: 1
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            src: item.imageHover,
                                                            alt: ""
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                                textStyle: "paragraph",
                                                textAlign: [
                                                    "center",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "left"
                                                ],
                                                fontSize: [
                                                    "14px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "21px"
                                                ],
                                                color: "#777",
                                                m: [
                                                    "40px auto 0",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "50px 0 0px 10px"
                                                ],
                                                maxW: [
                                                    "320px",
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                    "460px"
                                                ],
                                                fontWeight: "300",
                                                lineHeight: "1.3",
                                                _groupHover: {
                                                    color: "#fff"
                                                },
                                                children: item.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                                        display: [
                                            "flex",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "none"
                                        ],
                                        align: "center",
                                        justify: [
                                            "center",
                                            null,
                                            null,
                                            null,
                                            null,
                                            "left"
                                        ],
                                        mt: [
                                            "80px"
                                        ],
                                        mb: [
                                            "40px",
                                            null,
                                            null,
                                            ,
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        cursor: "pointer",
                                        onClick: function() {
                                            return handleOpenWatchVideoModal(item.link);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                width: "20px",
                                                src: icon_play_circle/* default */.Z,
                                                alt: ""
                                            }),
                                            colorScheme: "teal",
                                            variant: "link",
                                            color: "primary",
                                            fontWeight: "700",
                                            fontSize: [
                                                "12px",
                                                null,
                                                null,
                                                null,
                                                null,
                                                "24px"
                                            ],
                                            children: "Watch intro"
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(box/* Box */.xu, {
                pos: "relative",
                w: "100%",
                maxW: "1200px",
                p: [
                    "80px 0",
                    null,
                    null,
                    "140px 0 140px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                        justify: [
                            "center",
                            null,
                            null,
                            "space-between"
                        ],
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                pos: "absolute",
                                width: [
                                    "288px",
                                    "auto"
                                ],
                                left: [
                                    "-135px",
                                    "-359px"
                                ],
                                top: [
                                    "-350px",
                                    "-180px"
                                ],
                                zIndex: "-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: bg_circle_left,
                                    alt: "101Pay"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                flexDir: "column",
                                mb: [
                                    "70px",
                                    null,
                                    null,
                                    "unset"
                                ],
                                px: "16px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                        maxW: [
                                            "142px",
                                            null,
                                            null,
                                            "260px"
                                        ],
                                        mx: "auto",
                                        mb: [
                                            "20px",
                                            null,
                                            null,
                                            "80px"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: logo_101pay/* default */.Z,
                                            alt: "101Pay"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                        maxW: [
                                            "200px",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        mx: [
                                            "auto",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        order: [
                                            2,
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        mt: [
                                            "70px",
                                            null,
                                            null,
                                            "0"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: image_preview_101_pay,
                                            alt: "101 Pay splash screen and dashboard"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        color: "#777",
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            "21px"
                                        ],
                                        fontWeight: "300",
                                        maxW: [
                                            "280px",
                                            null,
                                            null,
                                            "425px"
                                        ],
                                        mt: [
                                            "0",
                                            null,
                                            null,
                                            "50px"
                                        ],
                                        mx: [
                                            "auto",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        textAlign: [
                                            "center",
                                            null,
                                            null,
                                            "left"
                                        ],
                                        order: [
                                            1,
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        children: "101 Pay is a feature-rich Super App for SMEs. With 101 Pay, SMEs can manage their Invoicing & Banking in one app. Banks & Fintechs can whitelabel 101 Pay."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                minheight: "900px",
                                background: "rgba(0, 0, 0, 0.15)",
                                width: "1px",
                                display: [
                                    "none",
                                    null,
                                    null,
                                    "block"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                                flexDir: "column",
                                px: "16px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                        mx: "auto",
                                        mt: [
                                            "-22px"
                                        ],
                                        maxW: [
                                            "250px",
                                            null,
                                            null,
                                            "470px"
                                        ],
                                        mb: [
                                            "20px",
                                            null,
                                            null,
                                            "80px"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: logo_digibank/* default */.Z,
                                            alt: "DigiBank Logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                                        maxW: [
                                            "330px",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        w: [
                                            "100%",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        mx: [
                                            "auto",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        order: [
                                            2,
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        mt: [
                                            "70px",
                                            null,
                                            null,
                                            "0"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: image_preview_digibank,
                                            alt: "DigiBank Webapp on desktop and mobile"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                                        color: "#777",
                                        fontSize: [
                                            "14px",
                                            null,
                                            null,
                                            "21px"
                                        ],
                                        fontWeight: "300",
                                        maxW: [
                                            "280px",
                                            null,
                                            null,
                                            "425px"
                                        ],
                                        mt: [
                                            "0",
                                            null,
                                            null,
                                            "90px"
                                        ],
                                        mx: [
                                            "auto",
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        textAlign: [
                                            "center",
                                            null,
                                            null,
                                            "left"
                                        ],
                                        order: [
                                            1,
                                            null,
                                            null,
                                            "unset"
                                        ],
                                        children: "A modern digital banking platform for corporate and personal banking."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(flex/* Flex */.k, {
                        justify: "center",
                        mt: [
                            "70px"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/products",
                            minW: [
                                "291px",
                                null,
                                null,
                                null,
                                null,
                                "444px"
                            ],
                            color: "primary",
                            bgColor: "white",
                            borderWidth: "2px",
                            borderRadius: "md",
                            borderColor: "#2d4fa7",
                            textAlign: "center",
                            justifyContent: "center",
                            style: {
                                textDecoration: "none",
                                borderColor: "#2d4fa7"
                            },
                            alignItems: "center",
                            left: "16px",
                            display: "flex",
                            height: [
                                "40px",
                                null,
                                null,
                                null,
                                null,
                                "54px"
                            ],
                            textStyle: "buttonText",
                            children: "Tell me more"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex/* Flex */.k, {
                pos: "relative",
                flexDir: "column",
                alignItems: "center",
                display: [
                    "flex",
                    null,
                    null,
                    "none"
                ],
                w: "100%",
                background: "#fff",
                zIndex: 2,
                pt: [
                    "0px",
                    null,
                    null,
                    "112px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(box/* Box */.xu, {
                        pos: "absolute",
                        display: [
                            "block",
                            "none"
                        ],
                        width: [
                            "360px",
                            "auto"
                        ],
                        right: [
                            "-60px",
                            "-276px"
                        ],
                        top: "-50px",
                        zIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: bg_circle_right,
                            alt: "101Pay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        as: "h2",
                        textStyle: "h2",
                        mb: [
                            "20px",
                            null,
                            null,
                            null,
                            null,
                            "39px"
                        ],
                        fontSize: [
                            "18px",
                            null,
                            null,
                            null,
                            null,
                            "38px"
                        ],
                        children: "Our Collaborative Approach"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* Text */.x, {
                        textStyle: "paragraph",
                        textAlign: "center",
                        px: "59px",
                        mb: [
                            "34.66px",
                            null,
                            null,
                            null,
                            null,
                            "79px"
                        ],
                        fontSize: [
                            "0.875rem",
                            null,
                            null,
                            null,
                            null,
                            "24px"
                        ],
                        children: "We follow a simple three step process to turn your idea into a great product."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stack/* Stack */.Kq, {
                        direction: [
                            "column",
                            null,
                            null,
                            null,
                            null,
                            "row"
                        ],
                        spacing: [
                            "59.59px",
                            null,
                            null,
                            null,
                            null,
                            "17px"
                        ],
                        mb: [
                            "56.25px",
                            null,
                            null,
                            null,
                            null,
                            "73px"
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeStepCard_HomeStepCard, {
                                step: 1,
                                title: "Discover",
                                description: "Understand your vision for your business and products"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeStepCard_HomeStepCard, {
                                step: 2,
                                title: "Partner and Co-Create",
                                description: "Leverage our platform to rapidly evolve the products"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeStepCard_HomeStepCard, {
                                step: 3,
                                title: "Launch",
                                description: "Launch the product to market quickly and continue to refine"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        href: "#",
                        minW: [
                            "291px",
                            null,
                            null,
                            null,
                            null,
                            "444px"
                        ],
                        mb: [
                            "55px",
                            null,
                            null,
                            null,
                            null,
                            "99px"
                        ],
                        onClick: function() {
                            return router.push("/approach");
                        },
                        children: "Understand our approach"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterHalfCircle/* default */.Z, {
                title: "Trusted by global organisations",
                description: "Customers choose 101 Digital for our proven experience and accelerated time to market.",
                buttonTitle: "See customer results",
                buttonLink: "/success-stories"
            })
        ]
    }));
};
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,454,325,77,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);